/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationReducer" />
import { BacklogConfigurationActionTypes, BacklogConfigurationActions } from "./BacklogConfigurationActions";
import { IBacklogConfiguration } from "./BacklogConfigurationContracts";

export function backlogConfigurationReducer(state: IBacklogConfiguration, action: BacklogConfigurationActions): IBacklogConfiguration {
    state = state || null;
    switch (action.type) {
        case BacklogConfigurationActionTypes.BacklogConfigurationLoadedAction: {
            return action.payload.backlogConfiguration;
        }
    }

    return state;
}
